import { Alert, CircularProgress, Slide } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import * as React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ClientContext } from "../../../store/context";
import { Post } from "../../api/ApiCallerService";
import { reservationApi } from "../../api/GardenoApi";
import {
  calculateCost,
  convertToLanguage,
  isEmail,
  isPhone,
} from "../../utils/generalUtils";
import InsurancecsAndExtras from "./InsurancecsAndExtras";
import ReservationForm from "./ReservationForm";
import ReservationPaymentMethod from "./ReservationPaymentMethod";
import ReservationSummary from "./ReservationSummary";

const steps = [
  "Extras and Insurances ",
  "Personal Details",
  "Payment Method",
  "Summary",
  "Complete",
];

function ReservationStepper() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [statusText, setStatusText] = React.useState("init");
  const [loading, setLoading] = React.useState(false);
  const {
    formBody,
    paymentMethod,
    reservationComments,
    pickUpDate,
    dropOffDate,
    dropOffLocation,
    pickUpLocation,
    pickUpTime,
    dropOffTime,
    carToReserve,
    extrasPicked,
    insuranceChecked,
    language,
  } = React.useContext(ClientContext);

  const navigate = useNavigate();
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const formValiation = () => {
    return (
      formBody?.customerName &&
      formBody?.customerName &&
      formBody?.customerPhone &&
      isPhone(formBody?.customerPhone) &&
      formBody?.customerMail &&
      isEmail(formBody?.customerMail) &&
      formBody?.customerAddress &&
      formBody?.customerCountry
    );
  };
  const [extrasCost, setExtrasCost] = React.useState(0);
  useEffect(() => {
    setExtrasCost(0);
    extrasPicked?.forEach((extra) => {
      extra.quantity != 0 &&
        setExtrasCost(
          (extrasCost) => extrasCost + extra.pricePerDay * extra.quantity
        );
    });
  }, [extrasPicked]);
  return (
    <Box sx={{ width: "95%", alignSelf: "center" }}>
      {statusText != null && statusText != "init" && (
        <Slide
          direction="right"
          in={statusText != null && statusText != "init"}
          sx={{ width: "60%", alignSelf: "center" }}
        >
          <Alert severity="error">{statusText}</Alert>
        </Slide>
      )}
      <Stepper
        activeStep={activeStep}
        sx={{ display: { xs: "none", lg: "flex" } }}
      >
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === 4 ? (
        <React.Fragment>
          <h3 sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </h3>
          <span>An email has been sent with the invoice</span>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button
              onClick={() => {
                navigate("/");
              }}
            >
              Back to Home Page
            </Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {activeStep === 0 && <InsurancecsAndExtras />}
          {activeStep === 1 && <ReservationForm />}
          {activeStep === 2 && <ReservationPaymentMethod />}
          {activeStep === 3 && <ReservationSummary />}
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0 || activeStep === steps.length - 1}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />

            {activeStep === 4 && loading ? (
              <CircularProgress />
            ) : (
              <Button
                disabled={
                  (activeStep === 1 && !formValiation()) ||
                  (activeStep === 2 && !paymentMethod)
                }
                onClick={
                  !(activeStep === 3)
                    ? handleNext
                    : () => {
                        setLoading(true);
                        Post(reservationApi.post, convertToLanguage(language), {
                          data: {
                            vehicleId: carToReserve.id,
                            insuranceId: insuranceChecked.id,
                            pickUpLocation: pickUpLocation,
                            dropOffLocation: dropOffLocation,
                            pickUpDate: `${pickUpDate.format(
                              "YYYY-MM-DD"
                            )}T${pickUpTime}:00`,
                            dropOffDate: `${dropOffDate.format(
                              "YYYY-MM-DD"
                            )}T${dropOffTime}:00`,
                            ...formBody,
                            comments: reservationComments,
                            extras: extrasPicked
                              .map((extra) => ({
                                extraId: extra.id,
                                quantity: extra.quantity,
                              }))
                              .filter((extra) => extra.quantity !== 0),
                            amount: calculateCost(
                              `${pickUpDate?.format(
                                "YYYY-MM-DD"
                              )}T${pickUpTime}:00`,
                              `${dropOffDate?.format(
                                "YYYY-MM-DD"
                              )}T${dropOffTime}:00`,
                              carToReserve?.currentRate +
                                extrasCost +
                                insuranceChecked?.pricePerDay
                            ),
                          },
                        }).then((response) => {
                          setLoading(false);
                          response.json().then((args) => {
                            setStatusText(args.result.errorMessage);
                            !args.result.errorMessage && handleNext();
                          });
                        });
                      }
                }
              >
                {activeStep === steps.length - 1 ? "Finish" : "Next"}
              </Button>
            )}
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
}

export default ReservationStepper;
